import React, { useEffect, useState } from 'react'

interface CopyToastProps {
  isVisible: boolean
  message?: string
}

const CopyToast: React.FC<CopyToastProps> = ({ isVisible, message = 'Copied to clipboard!' }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (isVisible) {
      setShow(true)
      const timer = setTimeout(() => setShow(false), 2000)
      return () => clearTimeout(timer)
    }
    return undefined
  }, [isVisible])

  if (!show) return null

  return (
    <>
      <style>{`
        @keyframes odc-copy-in {
          0% { transform: translateY(20px) scale(0.8); opacity: 0; }
          60% { transform: translateY(-4px) scale(1.05); opacity: 1; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
        @keyframes odc-copy-out {
          from { opacity: 1; transform: scale(1); }
          to { opacity: 0; transform: scale(0.8) translateY(-10px); }
        }
      `}</style>
      <div style={{
        position: 'fixed',
        bottom: 100,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 99999,
        animation: 'odc-copy-in 0.3s cubic-bezier(0.34,1.56,0.64,1)',
        pointerEvents: 'none',
      }}>
        <div style={{
          background: 'linear-gradient(135deg, rgba(6,148,148,0.95), rgba(6,120,120,0.95))',
          border: '1px solid rgba(6,148,148,0.6)',
          borderRadius: 50,
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          boxShadow: '0 8px 32px rgba(6,148,148,0.4), 0 2px 8px rgba(0,0,0,0.3)',
          backdropFilter: 'blur(10px)',
          whiteSpace: 'nowrap',
        }}>
          <span style={{ fontSize: 16 }}>✅</span>
          <span style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#fff',
            letterSpacing: 0.3,
          }}>
            {message}
          </span>
        </div>
      </div>
    </>
  )
}

export default CopyToast
